//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            violations: [],
            selectedViolation: null,
            name: null,
            date: moment().format('MM/DD/YY'),
            cost: null,
            description: null
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('resident-add-violation', function () {
            _this.getVoilations();
            _this.residentAddViolation();
        });
        Event.$on('refresh-resident-dashboard', this.refreshResidentDashboard);
        Event.$on('violation-added', this.violationAdded);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('resident-add-violation');
        Event.$off('refresh-resident-dashboard');
        Event.$off('violation-added');
    },

    methods: {
        getVoilations: function getVoilations() {
            var $el = this;
            axios.get("/prototype/person/residents/get-violation").then(function (response) {
                $el.violations = response.data;
            });
        },
        residentAddViolation: function residentAddViolation() {
            var $el = this;
            $el.$children[0].$data.showSmallModal = true;
        },
        refreshResidentDashboard: function refreshResidentDashboard() {
            var $el = this;
            $el.resident = $el.resident;
        },
        violationAdded: function violationAdded() {
            var $el = this;
            $el.$children[0].$data.showModal = true;
            this.$snotify.success('The violation was added');
        },

        saveViolation: function saveViolation() {
            var $el = this;
            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("resident_id", this.resident.id);
            formData.append("violation_id", this.selectedViolation.id);
            formData.append("description", this.description);
            formData.append("date", this.date);
            axios.post('/prototype/person/residents/add-violation', formData).then(function (response) {
                Event.$emit('violation-added', response.data);
                Event.$emit('violations-updated');
                Event.$emit('close-small-modal');
            });
        }
    },
    computed: {
        defaultAmount: {
            get: function get() {
                return this.selectedViolation ? this.selectedViolation.amount : '0.00';
            },
            set: function set(newValue) {
                newValue = this.selectedViolation ? this.selectedViolation.amount : '0.00';
            }

        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentAddViolation.vue
// module id = D+Jh
// module chunks = 0 1